module.exports = __webpack_public_path__ + "media/feature-icons/gps-3b68dd20.png";